import {DataFetcherRequest} from '@aboutyou/data-fetcher';
import {
  ShopStreamItem,
  ShopStreamItemV2,
} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/brand_hub/v1/service.types';
import {CategoryStreamItem} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/category_page/v1/stream/stream.types';
import {CategoryStreamItemV2} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/category_page/v1/stream/stream_v2.types';

interface Items {
  items: (
    | CategoryStreamItem
    | CategoryStreamItemV2
    | ShopStreamItemV2
    | ShopStreamItem
  )[];
}

type ProductStreamRequest<T extends Items> = () => DataFetcherRequest<T>;

export const useIsInitialStreamRequestEmpty = <T extends Items>(
  request: ProductStreamRequest<T>,
) => {
  return request().data?.items?.length === 0;
};
